import { useState, useEffect } from 'react';
import api from '../../../utils/api';

export const useComments = (book, filteredChapters, selectedIdx) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [postingComment, setPostingComment] = useState(false);
  const [commentError, setCommentError] = useState(null);

  // Fetch comments for the selected chapter
  useEffect(() => {
    if (!book || !filteredChapters[selectedIdx]) return;
    
    const fetchComments = async () => {
      setIsLoadingComments(true);
      setCommentError(null);
      try {
        const token = localStorage.getItem('app_token');
        const res = await api.get(
          `/api/books/${book.id}/chapters/${filteredChapters[selectedIdx].id}/comments`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setComments(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        setCommentError('Failed to load comments.');
        setComments([]);
      } finally {
        setIsLoadingComments(false);
      }
    };
    
    fetchComments();
  }, [book, filteredChapters, selectedIdx]);

  // Post a new comment
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    
    setPostingComment(true);
    setCommentError(null);
    
    try {
      const token = localStorage.getItem('app_token');
      const commentRes = await api.post(
        `/api/books/${book.id}/chapters/${filteredChapters[selectedIdx].id}/comments`,
        { commentText: newComment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Optimistically add the comment
      setComments([
        {
          id: commentRes.data.id,
          comment_text: newComment,
          name: 'You', // This should come from user context
          profile_picture: null,
          user_id: null,
          created_at: new Date().toISOString(),
        },
        ...comments,
      ]);
      setNewComment('');
    } catch (err) {
      setCommentError('Failed to post comment.');
    } finally {
      setPostingComment(false);
    }
  };

  return {
    comments,
    newComment,
    setNewComment,
    isLoadingComments,
    postingComment,
    commentError,
    handleCommentSubmit
  };
}; 